<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import mixin from "@/plugins/mixins/mixin"

export default {
	computed:{
		lxd: {
			get() {
				return this.$store.state.lxd.lxd;
			},
		},
		parameters: {
			get() {
				return this.$store.state.parameters;
			},
		},
	},
	mixins: [mixin],
	async mounted(){
		const payload = await this.$store.dispatch("dc4/verifyUser")
		if(payload && this.$route.name == "login"){
			this.$router.push("/oryxpdv/caixa")
		}
		if(payload)
			await this.$store.dispatch("dc4/verifyTerminal")

		this.enableShortKeys()
	}
};
</script>

<style lang="scss">
#app {
	font-family: Muli !important;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
